var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1602 44L33.6445 34.9375H22.1992L18.7031 44H15.3438L26.5156 15.3281H29.5039L40.5977 44H37.1602ZM32.6484 31.9883L29.3086 22.9844C29.2305 22.75 29.1003 22.3659 28.918 21.832C28.7487 21.2982 28.5729 20.7448 28.3906 20.1719C28.2083 19.599 28.0586 19.1367 27.9414 18.7852C27.8112 19.319 27.668 19.8529 27.5117 20.3867C27.3685 20.9076 27.2253 21.3958 27.082 21.8516C26.9388 22.2943 26.8151 22.6719 26.7109 22.9844L23.3125 31.9883H32.6484Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionA);
export default __webpack_public_path__ + "static/media/section-a.257b011bfd1812c918d88673780e72fd.svg";
export { ForwardRef as ReactComponent };